import { $ } from '@/libs/jquery/index'
import { LeadsMap } from '@/views/application/leads/shared/map/index'

export class LeadsContactsMap {
  public base: JQuery | null = null

  private readonly selectors: ISelectors = {
    base: '[data-selector="leadsContactsMap"]',
  }

  constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      this.init()
    }
  }

  public init(): void {
    this.base.each((index, city) => {
      const cityData = {
        container: city.dataset.container,
        lat: city.dataset.lat,
        lng: city.dataset.lng,
      }
      const cityMap = new LeadsMap(cityData)
    })
  }

}
